import { TechemTheme } from '@techem/techem-theme';
import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import entryWithCheckmarkIcon from '../../../../assets/icons/png/3x/icn-eed-ready@3x-schwarz.png';
import Icon, { ICONSIZE } from '../../../../../presentation/components/Icon';
import { ContentWrapper } from '../../../../components/offerpage/ContentWrapper';
import RedLinkButtonWithArrow from '../../../../../presentation/components/RedLinkButtonWithArrow';
import { useMediaQuery } from '../../../../../tools/hooks/useMediaQuery';
import { TrackerUtil } from '../../../../../tracking/TrackerUtil';
import CenteredContent from './CenteredContent';
import HighlightedEntryRow from './styled/HighlightedEntryRow';

interface EedInfoBoxProps {
  setEEDModalOpen: (open: boolean) => void;
}

const EedInfoBox: React.FC<EedInfoBoxProps> = ({ setEEDModalOpen }) => {
  const isMobile = useMediaQuery('(max-width: 767px)');
  const isXXSmall = useMediaQuery('(max-width: 375px)');

  const { t } = useTranslation();

  return (
    <HighlightedEntryRow className={`justify-content-center px-3 py-4 my-3`} data-gi="eed-info">
      <Col xs={12} md className={`${isXXSmall ? 'px-0' : ''}`}>
        <Row>
          <Col xs="auto" className="pe-0 ps-3" style={{ width: '40px' }}>
            <Icon
              iconSrc={entryWithCheckmarkIcon}
              size={ICONSIZE.small}
              alt="entry with checkmark"
            />
          </Col>
          <Col xs>
            <CenteredContent>
              <ContentWrapper
                color={TechemTheme.colors.contentPrimary}
                i18nKey={'pages.offer.infoBoxes.eed.title'}
              />
            </CenteredContent>
          </Col>
          <Col xs={12} md={11} className="my-3 ms-md-5 ps-md-2">
            <span className="copy d-inline-block">
              <ContentWrapper
                color={TechemTheme.colors.contentPrimary}
                i18nKey={'pages.offer.infoBoxes.eed.description'}
              />
              <p className="mb-0" style={{ whiteSpace: 'nowrap' }}>
                <RedLinkButtonWithArrow
                  ariaLabel={'Mehr Informationen zur EED'}
                  handleClick={() => {
                    TrackerUtil.trackLinkClick('offerpage_link_eed-modal', 'link_eed-modal');
                    setEEDModalOpen(true);
                  }}
                  additionalTestId="eed"
                >
                  {t('pageOfferMoreInfoInlineButtonText')}
                </RedLinkButtonWithArrow>
              </p>
            </span>
          </Col>
        </Row>
      </Col>
      <Col xs={12} md="auto" className={`mw-auto${isXXSmall ? ' px-0' : ''}`}>
        <Row className={`justify-content-between h-100${isMobile ? '' : ' d-grid'}`}>
          <Col
            xs={{ span: 'auto', order: 2 }}
            md={{ order: 1 }}
            className="my-auto my-md-0 px-md-3"
          >
            {
              <Row className="d-block d-md-none position-absolute" style={{ bottom: '32px' }}>
                <Col xs={12}>
                  <span
                    className="copy"
                    style={{
                      textDecoration: 'line-through',
                      color: '#007c94'
                    }}
                  >
                    &shy;
                  </span>
                </Col>
              </Row>
            }

            <Row className="">
              <Col xs={12}>
                <span className="copy text-bold" style={{ color: '#007c94' }}>
                  &shy;
                </span>
              </Col>
            </Row>

            {
              <Row className="mt-3 d-none d-md-block">
                <Col xs={12}>
                  <span
                    className="copy"
                    style={{
                      textDecoration: 'line-through',
                      color: '#007c94'
                    }}
                  >
                    &shy;
                  </span>
                </Col>
              </Row>
            }
          </Col>
          <Col
            xs={{ span: 'auto', order: 1 }}
            md={{ order: 2 }}
            className={`px-2 px-md-3 mt-auto ${isMobile ? 'ms-0' : 'ms-auto'}`}
          >
            &shy;
          </Col>
        </Row>
      </Col>
    </HighlightedEntryRow>
  );
};

export default EedInfoBox;
